/* global axios */
import ApiClient from '../ApiClient';

class AiBotUnansweredAPI extends ApiClient {
  constructor(botId) {
    super(`agent_bots/${botId}/unanswered_questions`, { accountScoped: true });
  }

  get({ status, category, page } = {}) {
    return axios.get(this.url, { params: { status, category, page } });
  }

  promote(id, { answer, keywords }) {
    return axios.post(`${this.url}/${id}/promote`, { answer, keywords });
  }

  dismiss(id) {
    return axios.post(`${this.url}/${id}/dismiss`);
  }
}

export default AiBotUnansweredAPI;
